import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import MyListingsCard from "./MyListingsCard";
import PropTypes from "prop-types";
import { getListings } from "../actions/listing";

const MyListings = ({ getListings, listings, user }) => {
  // Add - Add Listing Function - POST
  // Add Search
  // Show Message and not fetch products if listing id does not match user id

  useEffect(() => {
    getListings();
  }, []);

  return (
    <Fragment>
      <div>
        <Link to='/add-listing' className='btn btn-dark btn-block text-center'>
          Add Listing
        </Link>
      </div>
      <section className='container'>
        <h1 className='x-large text-center'>My Listings</h1>
        <div style={userStyle}>
          {listings.length === 0 ? (
            <div>Please Add Producuts</div>
          ) : (
            
            listings.map(
              (listing) =>
                listing.user_id === user.id && (
                  <MyListingsCard
                    key={listing.id}
                    listings={listing}
                    getListings={getListings}
                  />
                )
            )
          )}
        </div>
      </section>
    </Fragment>
  );
};

const userStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(3, 1fr)",
  gridGap: "1rem",
};

MyListings.propTypes = {
  getListings: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  listings: state.listing.listings,
  user: state.auth.user,
});

export default connect(mapStateToProps, { getListings })(MyListings);
